import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20abstract%20composition%20with%20warm%20coral%20and%20deep%20charcoal%20color%20palette%2C%20exploding%20geometric%20shapes%20and%20fragments%20representing%20breaking%20news%20and%20gossip%2C%20dynamic%20diagonal%20lines%20creating%20tension%20and%20movement%2C%20soft%20glow%20effect%20at%20center%2C%20modern%20editorial%20design%20aesthetic%2C%20no%20text%20or%20recognizable%20faces%2C%20artistic%20abstract%20style&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="黑料吃瓜网 - 全网最新网红黑料与八卦资讯"
          title="黑料吃瓜网 - 黑料吃瓜网站入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs md:text-sm text-background-50 font-medium">实时更新中</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight">
              全网黑料
              <br />
              吃瓜入口
            </h1>
            <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/80 max-w-md mx-auto lg:mx-0 leading-relaxed">
              黑料吃瓜网官网直连，第一时间捕捉全网最新网红黑料与明星八卦，
              每日吃瓜大赛劲爆内容持续更新，入口稳定在线不打烊。
            </p>
            <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/category/all"
                className="w-full sm:w-auto px-6 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                吃瓜大赛
                <i className="ri-fire-line ml-2"></i>
              </Link>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-md aspect-square">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-primary-400/30 to-accent-400/20 backdrop-blur-sm border border-background-50/10"></div>
              <div className="absolute top-6 right-6 flex flex-col items-end gap-1">
                <span className="text-4xl md:text-5xl font-bold text-background-50 font-heading">12K+</span>
                <span className="text-xs text-background-50/60">累计爆料</span>
              </div>
              <div className="absolute bottom-8 left-8">
                <span className="text-3xl md:text-4xl font-bold text-accent-400 font-heading">580万</span>
                <p className="text-xs text-background-50/60 mt-1">月活吃瓜群众</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}